import { Col, Form, Modal, Row } from "react-bootstrap";
import { Person } from "../../models";
import { AutoCol, ReadonlyGroup } from "../../component-library";

interface PersonModalProps {
    person: Person | undefined;
    show: boolean;
    onHide: () => void;
}

export function PersonModal({ person, show, onHide }: Readonly<PersonModalProps>) {
    return (
        <Modal show={show} onHide={onHide} centered size="xl">
            <Modal.Header closeButton>
                <Modal.Title>
                    {person?.firstName} {person?.lastName}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <AutoCol className="mb-3">
                        <ReadonlyGroup label="First Name" value={person?.firstName} />
                    </AutoCol>
                    <AutoCol className="mb-3">
                        <ReadonlyGroup label="Last Name" value={person?.lastName} />
                    </AutoCol>
                    <AutoCol className="mb-3">
                        <ReadonlyGroup label="Suffix" value={person?.suffix} />
                    </AutoCol>
                    <AutoCol className="mb-3">
                        <ReadonlyGroup label="Title" value={person?.title} />
                    </AutoCol>
                    <AutoCol className="mb-3">
                        <Form.Check type="checkbox" label="Criteria-Based" checked={person?.isCriteriaBased} readOnly />
                        <Form.Check type="checkbox" label="International" checked={person?.isInternational} readOnly />
                    </AutoCol>
                </Row>
                <Row>
                    <Col md={6} className="mb-3">
                        <ReadonlyGroup label="Notes" value={person?.notes} as="textarea" />
                    </Col>
                    <Col md={6} className="mb-3">
                        <ReadonlyGroup label="Processing Criteria" value={person?.processingCriteria} as="textarea" />
                    </Col>
                    <Col md={6} className="mb-3">
                        <ReadonlyGroup label="Shipping Criteria" value={person?.shippingCriteria} as="textarea" />
                    </Col>
                    <Col md={6} className="mb-3">
                        <ReadonlyGroup label="DMEK Criteria" value={person?.dmekCriteria} as="textarea" />
                    </Col>
                    <Col md={3} className="mb-3">
                        <ReadonlyGroup label="DSAEK Min" value={person?.dsaekMin} as="textarea" />
                    </Col>
                    <Col md={3} className="mb-3">
                        <ReadonlyGroup label="DSAEK Max" value={person?.dsaekMax} as="textarea" />
                    </Col>
                    <Col md={6} className="mb-3">
                        <ReadonlyGroup label="CAIRS Criteria" value={person?.cairsCriteria} as="textarea" />
                    </Col>
                    <Col md={6} className="mb-3">
                        <ReadonlyGroup label="Precut Criteria" value={person?.precutCriteria} as="textarea" />
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
}
